// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { text } from '../../tokens/themeColors/text';
export var textFieldColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var tx = text(mode);
    return {
        active: {
            border: bd.action100
        },
        default: {
            background: bg.level0,
            border: bd.heavy,
            hintText: tx.secondary,
            labelText: tx.secondary,
            placeholderText: tx.tertiary,
            text: tx.primary
        },
        disabled: {
            background: bg.state.disabledTransparent,
            border: bd.default,
            hintText: tx.disabled,
            labelText: tx.disabled,
            placeholderText: tx.disabled,
            text: tx.disabled3
        },
        error: {
            border: bd.status.error,
            hintText: tx.status.errorAlt,
            labelText: tx.status.errorAlt
        },
        hover: {
            background: bg.level50,
            border: bd.active
        },
        readonly: {
            border: bd.default,
            hintText: tx.secondary,
            labelText: tx.secondary,
            placeholderText: tx.tertiary,
            text: tx.secondary
        }
    };
};

//# sourceMappingURL=textFieldColors.js.map